import { createFileRoute } from "@tanstack/react-router";
import SitePage from "@/components/SitePage";
import { buildHead, breadcrumbLD, touristTripLD, SITE_URL } from "@/content/seo";
import { landingContent, pageFaqLD } from "@/content/landing-content";

const TITLE = "Private Yacht Charter Vilamoura · Morningstar · Algarve";
const DESC =
  "Private yacht charter from Vilamoura aboard Morningstar — a 200 m² yacht for up to 18 guests, fully crewed and catered. Half-day, sunset and full-day Algarve charters.";
const PATH = "/private-yacht-charter-vilamoura";
const URL = `${SITE_URL}${PATH}`;
const CONTENT = landingContent.privateYachtVilamoura;

export const Route = createFileRoute("/private-yacht-charter-vilamoura")({
  component: () => (
    <SitePage
      lang="en"
      heroOverride={{
        eyebrow: "Private Yacht Charter · Vilamoura · Algarve",
        title: "Private yacht charter from Vilamoura on ",
        titleAccent: "Morningstar.",
        sub: "A 200 m² private yacht for up to 18 guests, departing from Marina de Vilamoura. Crewed, catered and entirely yours — half-day, sunset, Benagil Cave and full-day Algarve charters.",
        ctaPrimary: "View charters",
        ctaSecondary: "Request a charter",
      }}
      pageContent={CONTENT.en}
    />
  ),
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "private yacht charter Vilamoura, Vilamoura yacht charter, yacht hire Vilamoura, Algarve yacht charter, luxury yacht charter Algarve, Morningstar yacht",
      altPath: { en: PATH, pt: "/pt/charter-iate-privado-vilamoura" },
      extraScripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            touristTripLD({
              name: "Private Yacht Charter from Vilamoura",
              description: DESC,
              url: URL,
            }),
          ),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify(
            breadcrumbLD([
              { name: "Home", path: "/" },
              { name: "Private Yacht Charter Vilamoura", path: PATH },
            ]),
          ),
        },
        { type: "application/ld+json", children: JSON.stringify(pageFaqLD(CONTENT.en.faqs)) },
      ],
    }),
});